/**
 * Homepage announcement marquee — pause animation on touch (mobile parity with desktop hover).
 */
(function () {
  var bar = document.querySelector('.ark-home-announcement');
  if (!bar) return;

  var pausedClass = 'is-paused';

  function pause() {
    bar.classList.add(pausedClass);
  }

  function resume() {
    bar.classList.remove(pausedClass);
  }

  bar.addEventListener('touchstart', pause, { passive: true });
  bar.addEventListener('touchend', resume, { passive: true });
  bar.addEventListener('touchcancel', resume, { passive: true });
})();
